import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "participant-header toggleswitch" }
const _hoisted_2 = { class: "participant-header-top" }
const _hoisted_3 = { class: "participant-header-title-wrap" }
const _hoisted_4 = { class: "participant-header-title" }
const _hoisted_5 = { class: "participant-header-actions" }
const _hoisted_6 = { class: "btn btn-secondary btn-size-header-main" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "btn-group" }
const _hoisted_10 = {
  type: "button",
  class: "btn btn-primary btn-size-header-main dropdown-toggle",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_14 = { class: "dropdown-item cursor-pointer" }
const _hoisted_15 = { class: "stats-row" }
const _hoisted_16 = {
  key: 0,
  class: "stat-card"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "stat-card-body" }
const _hoisted_19 = { class: "stat-card-number" }
const _hoisted_20 = { class: "stat-card-label" }
const _hoisted_21 = { class: "position-relative" }
const _hoisted_22 = {
  key: 1,
  class: "stat-card"
}
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "stat-card-body" }
const _hoisted_25 = { class: "stat-card-number" }
const _hoisted_26 = { class: "stat-card-label" }
const _hoisted_27 = { class: "position-relative" }
const _hoisted_28 = { class: "stat-card" }
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "stat-card-body" }
const _hoisted_31 = { class: "stat-card-number" }
const _hoisted_32 = { class: "stat-card-label" }
const _hoisted_33 = { class: "position-relative" }
const _hoisted_34 = { class: "stat-card" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "stat-card-body" }
const _hoisted_37 = { class: "stat-card-number" }
const _hoisted_38 = { class: "stat-card-label" }
const _hoisted_39 = { class: "position-relative" }
const _hoisted_40 = { class: "privacy-setting" }
const _hoisted_41 = { class: "privacy-setting-text" }
const _hoisted_42 = { class: "privacy-setting-label" }
const _hoisted_43 = { class: "privacy-setting-desc" }
const _hoisted_44 = { class: "switch" }
const _hoisted_45 = ["checked"]
const _hoisted_46 = { class: "privacy-setting" }
const _hoisted_47 = { class: "privacy-setting-text" }
const _hoisted_48 = { class: "privacy-setting-label" }
const _hoisted_49 = { class: "privacy-setting-desc" }
const _hoisted_50 = { class: "switch" }
const _hoisted_51 = ["checked"]
const _hoisted_52 = { class: "profile-photo-section" }
const _hoisted_53 = { class: "profile-photo-info" }
const _hoisted_54 = { class: "profile-photo-label" }
const _hoisted_55 = { class: "profile-photo-hint" }
const _hoisted_56 = { class: "drawer-form-row" }
const _hoisted_57 = { class: "drawer-form-group" }
const _hoisted_58 = { class: "drawer-label" }
const _hoisted_59 = ["placeholder"]
const _hoisted_60 = { class: "drawer-form-group" }
const _hoisted_61 = { class: "drawer-label" }
const _hoisted_62 = ["placeholder"]
const _hoisted_63 = { class: "drawer-form-row" }
const _hoisted_64 = { class: "drawer-form-group" }
const _hoisted_65 = { class: "drawer-label" }
const _hoisted_66 = ["placeholder"]
const _hoisted_67 = { class: "drawer-form-group" }
const _hoisted_68 = { class: "drawer-label" }
const _hoisted_69 = ["placeholder"]
const _hoisted_70 = { class: "drawer-form-row" }
const _hoisted_71 = { class: "drawer-form-group" }
const _hoisted_72 = { class: "drawer-label" }
const _hoisted_73 = ["placeholder"]
const _hoisted_74 = { class: "drawer-form-group" }
const _hoisted_75 = { class: "drawer-label" }
const _hoisted_76 = ["placeholder"]
const _hoisted_77 = { class: "drawer-form-group" }
const _hoisted_78 = { class: "drawer-label" }
const _hoisted_79 = { class: "about-char-count" }
const _hoisted_80 = ["placeholder"]
const _hoisted_81 = { class: "drawer-form-group" }
const _hoisted_82 = { class: "drawer-label" }
const _hoisted_83 = ["placeholder"]
const _hoisted_84 = { class: "drawer-form-row" }
const _hoisted_85 = { class: "drawer-form-group" }
const _hoisted_86 = { class: "drawer-label" }
const _hoisted_87 = { class: "drawer-form-group" }
const _hoisted_88 = { class: "drawer-label" }
const _hoisted_89 = { class: "drawer-form-row" }
const _hoisted_90 = { class: "drawer-form-group" }
const _hoisted_91 = { class: "drawer-label" }
const _hoisted_92 = ["placeholder"]
const _hoisted_93 = { class: "drawer-form-group" }
const _hoisted_94 = { class: "drawer-label" }
const _hoisted_95 = ["placeholder"]
const _hoisted_96 = { class: "add-section-heading" }
const _hoisted_97 = { class: "position-relative" }
const _hoisted_98 = { class: "drawer-form-group" }
const _hoisted_99 = ["placeholder"]
const _hoisted_100 = { class: "add-section-heading" }
const _hoisted_101 = {
  key: 0,
  class: "add-groups-grid"
}
const _hoisted_102 = ["checked", "onChange"]
const _hoisted_103 = { class: "import-subtitle" }
const _hoisted_104 = { class: "import-section-title" }
const _hoisted_105 = { class: "import-rules" }
const _hoisted_106 = {
  href: "javascript:void(0)",
  class: "import-template-link"
}
const _hoisted_107 = { class: "import-rules-sub" }
const _hoisted_108 = { class: "import-custom-fields" }
const _hoisted_109 = { class: "import-custom-fields-title position-relative" }
const _hoisted_110 = { class: "import-custom-fields-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SideDrawer = _resolveComponent("SideDrawer")!
  const _component_ModalPopup = _resolveComponent("ModalPopup")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('Participants')), 1),
        _cache[36] || (_cache[36] = _createElementVNode("div", { class: "participant-header-underline" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", _hoisted_6, [
          _createElementVNode("img", {
            src: _ctx.shareIcon,
            class: "menu-item-icon"
          }, null, 8, _hoisted_7),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.Share')), 1)
        ]),
        _createElementVNode("button", {
          class: "btn btn-secondary btn-size-header-main",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.OpenPrivacyDrawer && _ctx.OpenPrivacyDrawer(...args)))
        }, [
          _createElementVNode("img", {
            src: _ctx.privacyIcon,
            class: "menu-item-icon"
          }, null, 8, _hoisted_8),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.AppPrivacy')), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", _hoisted_10, [
            _createElementVNode("img", { src: _ctx.addIcon }, null, 8, _hoisted_11),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('Participant.AddParticipants')), 1),
            _createElementVNode("img", {
              src: _ctx.dropDownIcon,
              class: "margin-left-10 margin-right-0"
            }, null, 8, _hoisted_12)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("a", {
              class: "dropdown-item cursor-pointer",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.OpenAddDrawer && _ctx.OpenAddDrawer(...args)))
            }, _toDisplayString(_ctx.$t('Participant.AddManually')), 1),
            _createElementVNode("a", {
              class: "dropdown-item cursor-pointer",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.OpenImportDrawer && _ctx.OpenImportDrawer(...args)))
            }, _toDisplayString(_ctx.$t('Participant.ImportFromFile')), 1),
            _createElementVNode("a", _hoisted_14, _toDisplayString(_ctx.$t('Participant.InviteByEmail')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      (_ctx.enableRegistrationSystem)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("img", { src: _ctx.invitationSentIcon }, null, 8, _hoisted_17),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.stats.totalInvitationsSent), 1),
              _createElementVNode("div", _hoisted_20, [
                _createTextVNode(_toDisplayString(_ctx.$t('Participant.TotalInvitationsSent')) + " ", 1),
                _createElementVNode("span", _hoisted_21, [
                  _createElementVNode("i", {
                    class: "fa fa-info-circle overlay-info",
                    "aria-hidden": "true",
                    onMouseover: _cache[3] || (_cache[3] = ($event: any) => (_ctx.ShowTooltip('invitationsSent'))),
                    onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.HideTooltip('invitationsSent')))
                  }, null, 32),
                  _withDirectives(_createElementVNode("div", { class: "information-icon-div" }, _toDisplayString(_ctx.$t('Participant.TotalInvitationsSentTooltip')), 513), [
                    [_vShow, _ctx.tooltips.invitationsSent]
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.enableRegistrationSystem)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("img", { src: _ctx.registrationsIcon }, null, 8, _hoisted_23),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.stats.registrationsComplete), 1),
              _createElementVNode("div", _hoisted_26, [
                _createTextVNode(_toDisplayString(_ctx.$t('Participant.RegistrationsComplete')) + " ", 1),
                _createElementVNode("span", _hoisted_27, [
                  _createElementVNode("i", {
                    class: "fa fa-info-circle overlay-info",
                    "aria-hidden": "true",
                    onMouseover: _cache[5] || (_cache[5] = ($event: any) => (_ctx.ShowTooltip('registrations'))),
                    onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.HideTooltip('registrations')))
                  }, null, 32),
                  _withDirectives(_createElementVNode("div", { class: "information-icon-div" }, _toDisplayString(_ctx.$t('Participant.RegistrationsCompleteTooltip')), 513), [
                    [_vShow, _ctx.tooltips.registrations]
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("img", { src: _ctx.joinedEventIcon }, null, 8, _hoisted_29),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.stats.joinedEvent), 1),
          _createElementVNode("div", _hoisted_32, [
            _createTextVNode(_toDisplayString(_ctx.$t('Participant.JoinedEvent')) + " ", 1),
            _createElementVNode("span", _hoisted_33, [
              _createElementVNode("i", {
                class: "fa fa-info-circle overlay-info",
                "aria-hidden": "true",
                onMouseover: _cache[7] || (_cache[7] = ($event: any) => (_ctx.ShowTooltip('joinedEvent'))),
                onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (_ctx.HideTooltip('joinedEvent')))
              }, null, 32),
              _withDirectives(_createElementVNode("div", { class: "information-icon-div" }, _toDisplayString(_ctx.$t('Participant.JoinedEventTooltip')), 513), [
                [_vShow, _ctx.tooltips.joinedEvent]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("img", { src: _ctx.checkedInIcon }, null, 8, _hoisted_35),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.stats.checkedIn), 1),
          _createElementVNode("div", _hoisted_38, [
            _createTextVNode(_toDisplayString(_ctx.$t('Participant.CheckedIn')) + " ", 1),
            _createElementVNode("span", _hoisted_39, [
              _createElementVNode("i", {
                class: "fa fa-info-circle overlay-info",
                "aria-hidden": "true",
                onMouseover: _cache[9] || (_cache[9] = ($event: any) => (_ctx.ShowTooltip('checkedIn'))),
                onMouseleave: _cache[10] || (_cache[10] = ($event: any) => (_ctx.HideTooltip('checkedIn')))
              }, null, 32),
              _withDirectives(_createElementVNode("div", { class: "information-icon-div" }, _toDisplayString(_ctx.$t('Participant.CheckedInTooltip')), 513), [
                [_vShow, _ctx.tooltips.checkedIn]
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_SideDrawer, {
      "show-drawer": _ctx.showPrivacyDrawer,
      title: _ctx.$t('Participant.AppPrivacy'),
      "show-footer": false,
      onClose: _ctx.ClosePrivacyDrawer
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('Participant.Privacy.DisplayInApp')), 1),
            _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t('Participant.Privacy.DisplayInAppDesc')), 1)
          ]),
          _createElementVNode("label", _hoisted_44, [
            _createElementVNode("input", {
              type: "checkbox",
              checked: _ctx.privacyDisplayInApp,
              onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.RequestPrivacyToggle('displayInApp')), ["prevent"]))
            }, null, 8, _hoisted_45),
            _cache[37] || (_cache[37] = _createElementVNode("span", { class: "slider round" }, null, -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t('Participant.Privacy.HideEmails')), 1),
            _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('Participant.Privacy.HideEmailsDesc')), 1)
          ]),
          _createElementVNode("label", _hoisted_50, [
            _createElementVNode("input", {
              type: "checkbox",
              checked: _ctx.privacyHideEmails,
              onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.RequestPrivacyToggle('hideEmails')), ["prevent"]))
            }, null, 8, _hoisted_51),
            _cache[38] || (_cache[38] = _createElementVNode("span", { class: "slider round" }, null, -1))
          ])
        ])
      ]),
      _: 1
    }, 8, ["show-drawer", "title", "onClose"]),
    (_ctx.showPrivacyConfirmModal)
      ? (_openBlock(), _createBlock(_component_ModalPopup, {
          key: 0,
          "show-modal-popup": _ctx.showPrivacyConfirmModal,
          "header-content": _ctx.$t('Confirmation'),
          "body-heading": _ctx.modalPopupHeading,
          "body-content": _ctx.privacyConfirmBodyKey,
          "show-cancel-button": _ctx.modalPopupShowCancelButton,
          "cancel-button-text": _ctx.modalPopupCancelButtonText,
          "confirm-button-text": _ctx.modalPopupConfirmButtonText,
          "show-close-button": _ctx.showCloseButton,
          onConfirmClick: _ctx.OnPrivacyConfirm
        }, null, 8, ["show-modal-popup", "header-content", "body-heading", "body-content", "show-cancel-button", "cancel-button-text", "confirm-button-text", "show-close-button", "onConfirmClick"]))
      : _createCommentVNode("", true),
    _createVNode(_component_SideDrawer, {
      "show-drawer": _ctx.showAddDrawer,
      title: _ctx.$t('Participant.AddDrawerTitle'),
      "confirm-disabled": _ctx.addForm.email.trim() === '',
      width: '750px',
      onClose: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showAddDrawer = false)),
      onCancel: _cache[29] || (_cache[29] = ($event: any) => (_ctx.showAddDrawer = false)),
      onConfirm: _ctx.ConfirmAddParticipant
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_52, [
          _cache[39] || (_cache[39] = _createElementVNode("div", { class: "profile-photo-placeholder" }, [
            _createElementVNode("svg", {
              width: "32",
              height: "32",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "#9ca3af",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("rect", {
                x: "3",
                y: "3",
                width: "18",
                height: "18",
                rx: "2",
                ry: "2"
              }),
              _createElementVNode("circle", {
                cx: "8.5",
                cy: "8.5",
                r: "1.5"
              }),
              _createElementVNode("polyline", { points: "21 15 16 10 5 21" })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.$t('Participant.Add.ProfilePhoto')), 1),
            _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t('Participant.Add.PhotoHint')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t('Participant.Add.FirstName')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.addForm.firstName) = $event)),
              type: "text",
              class: "form-control",
              placeholder: _ctx.$t('Participant.Add.FirstNamePlaceholder')
            }, null, 8, _hoisted_59), [
              [_vModelText, _ctx.addForm.firstName]
            ])
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.$t('Participant.Add.LastName')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.addForm.lastName) = $event)),
              type: "text",
              class: "form-control",
              placeholder: _ctx.$t('Participant.Add.LastNamePlaceholder')
            }, null, 8, _hoisted_62), [
              [_vModelText, _ctx.addForm.lastName]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.$t('Participant.Add.Title')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.addForm.title) = $event)),
              type: "text",
              class: "form-control",
              placeholder: _ctx.$t('Participant.Add.TitlePlaceholder')
            }, null, 8, _hoisted_66), [
              [_vModelText, _ctx.addForm.title]
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.$t('Participant.Add.Company')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.addForm.company) = $event)),
              type: "text",
              class: "form-control",
              placeholder: _ctx.$t('Participant.Add.CompanyPlaceholder')
            }, null, 8, _hoisted_69), [
              [_vModelText, _ctx.addForm.company]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_70, [
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("label", _hoisted_72, [
              _createTextVNode(_toDisplayString(_ctx.$t('Participant.Add.Email')), 1),
              _cache[40] || (_cache[40] = _createElementVNode("span", { class: "required-star" }, "*", -1))
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.addForm.email) = $event)),
              type: "email",
              class: "form-control",
              placeholder: _ctx.$t('Participant.Add.EmailPlaceholder')
            }, null, 8, _hoisted_73), [
              [_vModelText, _ctx.addForm.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.$t('Participant.Add.Phone')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.addForm.phone) = $event)),
              type: "tel",
              class: "form-control",
              placeholder: _ctx.$t('Participant.Add.PhonePlaceholder')
            }, null, 8, _hoisted_76), [
              [_vModelText, _ctx.addForm.phone]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_77, [
          _createElementVNode("label", _hoisted_78, [
            _createTextVNode(_toDisplayString(_ctx.$t('Participant.Add.About')) + " ", 1),
            _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.addForm.about.length) + "/500", 1)
          ]),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.addForm.about) = $event)),
            class: "form-control",
            rows: "3",
            maxlength: "500",
            placeholder: _ctx.$t('Participant.Add.AboutPlaceholder')
          }, null, 8, _hoisted_80), [
            [_vModelText, _ctx.addForm.about]
          ])
        ]),
        _createElementVNode("div", _hoisted_81, [
          _createElementVNode("label", _hoisted_82, _toDisplayString(_ctx.$t('Participant.Add.Website')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.addForm.website) = $event)),
            type: "url",
            class: "form-control",
            placeholder: _ctx.$t('Participant.Add.WebsitePlaceholder')
          }, null, 8, _hoisted_83), [
            [_vModelText, _ctx.addForm.website]
          ])
        ]),
        _createElementVNode("div", _hoisted_84, [
          _createElementVNode("div", _hoisted_85, [
            _createElementVNode("label", _hoisted_86, _toDisplayString(_ctx.$t('Participant.Add.XHandle')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.addForm.xHandle) = $event)),
              type: "text",
              class: "form-control"
            }, null, 512), [
              [_vModelText, _ctx.addForm.xHandle]
            ])
          ]),
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("label", _hoisted_88, _toDisplayString(_ctx.$t('Participant.Add.Instagram')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.addForm.instagram) = $event)),
              type: "text",
              class: "form-control"
            }, null, 512), [
              [_vModelText, _ctx.addForm.instagram]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_89, [
          _createElementVNode("div", _hoisted_90, [
            _createElementVNode("label", _hoisted_91, _toDisplayString(_ctx.$t('Participant.Edit.LinkedInProfile')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.addForm.linkedIn) = $event)),
              type: "url",
              class: "form-control",
              placeholder: _ctx.$t('Participant.Edit.LinkedInPlaceholder')
            }, null, 8, _hoisted_92), [
              [_vModelText, _ctx.addForm.linkedIn]
            ])
          ]),
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("label", _hoisted_94, _toDisplayString(_ctx.$t('Participant.Edit.FacebookProfile')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.addForm.facebook) = $event)),
              type: "text",
              class: "form-control",
              placeholder: _ctx.$t('Participant.Edit.FacebookPlaceholder')
            }, null, 8, _hoisted_95), [
              [_vModelText, _ctx.addForm.facebook]
            ])
          ])
        ]),
        _cache[41] || (_cache[41] = _createElementVNode("div", { class: "add-section-divider" }, null, -1)),
        _createElementVNode("div", _hoisted_96, [
          _createTextVNode(_toDisplayString(_ctx.$t('Participant.Edit.Notes')) + " ", 1),
          _createElementVNode("span", _hoisted_97, [
            _createElementVNode("i", {
              class: "fa fa-info-circle overlay-info",
              "aria-hidden": "true",
              onMouseover: _cache[25] || (_cache[25] = ($event: any) => (_ctx.ShowTooltip('addNotes'))),
              onMouseleave: _cache[26] || (_cache[26] = ($event: any) => (_ctx.HideTooltip('addNotes')))
            }, null, 32),
            _withDirectives(_createElementVNode("div", { class: "information-icon-div" }, _toDisplayString(_ctx.$t('Participant.Add.NotesHint')), 513), [
              [_vShow, _ctx.tooltips.addNotes]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_98, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.addForm.note) = $event)),
            class: "form-control",
            rows: "4",
            placeholder: _ctx.$t('Participant.Edit.NotePlaceholder')
          }, null, 8, _hoisted_99), [
            [_vModelText, _ctx.addForm.note]
          ])
        ]),
        _cache[42] || (_cache[42] = _createElementVNode("div", { class: "add-section-divider" }, null, -1)),
        _createElementVNode("div", _hoisted_100, _toDisplayString(_ctx.$t('Participant.Edit.Groups')), 1),
        (_ctx.allGroups.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allGroups, (group) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: group.Id,
                  class: "add-group-item"
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: _ctx.addForm.groupIds.includes(group.Id),
                    onChange: ($event: any) => (_ctx.ToggleAddGroup(group.Id))
                  }, null, 40, _hoisted_102),
                  _createTextVNode(" " + _toDisplayString(group.Name), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show-drawer", "title", "confirm-disabled", "onConfirm"]),
    _createVNode(_component_SideDrawer, {
      "show-drawer": _ctx.showImportDrawer,
      title: _ctx.$t('Participant.Import.DrawerTitle'),
      "confirm-button-text": _ctx.$t('Participant.Import.ImportButton'),
      "confirm-disabled": !_ctx.importFile,
      onClose: _cache[34] || (_cache[34] = ($event: any) => (_ctx.showImportDrawer = false)),
      onCancel: _cache[35] || (_cache[35] = ($event: any) => (_ctx.showImportDrawer = false)),
      onConfirm: _ctx.ConfirmImport
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_103, _toDisplayString(_ctx.$t('Participant.Import.Subtitle')), 1),
        _createElementVNode("div", _hoisted_104, _toDisplayString(_ctx.$t('Participant.Import.BeforeUpload')), 1),
        _createElementVNode("ul", _hoisted_105, [
          _createElementVNode("li", null, [
            _createTextVNode(_toDisplayString(_ctx.$t('Participant.Import.UseTemplate')) + " ", 1),
            _createElementVNode("a", _hoisted_106, _toDisplayString(_ctx.$t('Participant.Import.ExcelTemplate')), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('Participant.Import.EmailRequired')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.Import.EmailRequiredDesc')) + " ", 1),
            _createElementVNode("ul", _hoisted_107, [
              _createElementVNode("li", null, _toDisplayString(_ctx.$t('Participant.Import.NoMissing')), 1),
              _createElementVNode("li", null, _toDisplayString(_ctx.$t('Participant.Import.NoDuplicates')), 1)
            ])
          ]),
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('Participant.Import.OnlyXlsx', {maxImportLimit: _ctx.maxImportLimit})), 1),
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('Participant.Import.SemicolonGroups')), 1),
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('Participant.Import.OverwriteExisting')), 1)
        ]),
        _cache[45] || (_cache[45] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("div", _hoisted_108, [
          _createElementVNode("div", _hoisted_109, [
            _createTextVNode(_toDisplayString(_ctx.$t('Participant.Import.CustomFieldsTitle')) + " ", 1),
            _createElementVNode("span", null, [
              _createElementVNode("i", {
                class: "fa fa-info-circle overlay-info",
                "aria-hidden": "true",
                onMouseover: _cache[30] || (_cache[30] = ($event: any) => (_ctx.ShowTooltip('customFields'))),
                onMouseleave: _cache[31] || (_cache[31] = ($event: any) => (_ctx.HideTooltip('customFields')))
              }, null, 32),
              _withDirectives(_createElementVNode("div", { class: "information-icon-div import-custom-fields-tooltip" }, _toDisplayString(_ctx.$t('Participant.Import.CustomFieldsTooltip')), 513), [
                [_vShow, _ctx.tooltips.customFields]
              ])
            ])
          ]),
          _createElementVNode("ul", _hoisted_110, [
            _createElementVNode("li", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('Participant.Import.CustomFieldsCreate')) + " ", 1),
              _createVNode(_component_router_link, {
                to: { name: 'myinformation' },
                class: "import-myinfo-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Participant.Import.MyInformation')) + " ", 1),
                  _cache[43] || (_cache[43] = _createElementVNode("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    class: "import-external-icon"
                  }, [
                    _createElementVNode("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" }),
                    _createElementVNode("polyline", { points: "15 3 21 3 21 9" }),
                    _createElementVNode("line", {
                      x1: "10",
                      y1: "14",
                      x2: "21",
                      y2: "3"
                    })
                  ], -1))
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.Import.BeforeImporting')), 1)
            ]),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('Participant.Import.CustomFieldsHint2')), 1)
          ])
        ]),
        _createElementVNode("input", {
          ref: "fileInput",
          type: "file",
          accept: ".xlsx",
          class: "import-file-input",
          onChange: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.OnFileSelected && _ctx.OnFileSelected(...args)))
        }, null, 544),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary btn-size-default",
          onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.TriggerFileInput && _ctx.TriggerFileInput(...args)))
        }, [
          _cache[44] || (_cache[44] = _createElementVNode("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            class: "margin-right-5"
          }, [
            _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
            _createElementVNode("polyline", { points: "17 8 12 3 7 8" }),
            _createElementVNode("line", {
              x1: "12",
              y1: "3",
              x2: "12",
              y2: "15"
            })
          ], -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.importFile ? _ctx.importFile.name : _ctx.$t('Participant.Import.UploadFile')), 1)
        ])
      ]),
      _: 1
    }, 8, ["show-drawer", "title", "confirm-button-text", "confirm-disabled", "onConfirm"])
  ]))
}